import React, { Component } from 'react'
import { forIn } from 'lodash'
import copy from 'fast-copy'

import { connect } from 'react-redux'

import PopMenu from 'layout/header/pop-menu'
import { doClickEventListeners } from 'utils'

class DashboardTasksStatus extends Component {
    testRef = null 

    componentWillMount() {
        const {
            project,
            task
        } = this.props

        this.primaryStatusColumn = project.columns ? project.columns.find(column => {
            return column.type == 'STATUS' && column.is_primary
        }) : null
    }

    componentWillUpdate = nextProps => {
        if(!this.props.isOpen && nextProps.isOpen){
			doClickEventListeners(this.assessClose)
        }else if(this.props.isOpen && !nextProps.isOpen){
            doClickEventListeners(this.assessClose, true)
        }
    }

    assessClose = e => {
        const {
            isOpen,
            closeMenu,
            outerRef
        } = this.props

        if(this.innerRef && !this.innerRef.contains(e.target) && outerRef && !outerRef.contains(e.target) && isOpen) {
            closeMenu()
        }
    }

    setStatus = id => {
        const {
            task,
            updateTask,
        } = this.props

        if(!this.primaryStatusColumn){
            return 
        }

        const clonedTask = copy(task)
        clonedTask.column_data[this.primaryStatusColumn.id] = id

        updateTask(clonedTask)
    }
    
    render() {
        const {
            task,
            allStatuses,
            statusId,
            isOpen,
            closeMenu,
            shouldGoUp
        } = this.props

        const options = []

        if(isOpen){
            forIn(allStatuses, status => {
                let statusName = status.name

                if(this.primaryStatusColumn && this.primaryStatusColumn.data){
                    this.primaryStatusColumn.data.some(loopedColumn => {
                        if(loopedColumn.status_id === status.id){
                            if(loopedColumn.custom_name){
                                statusName = loopedColumn.custom_name
                            }

                            //break the loop regardless.
                            return true
                        }
                    })
                }

                if(statusName){
                    options.push({
                        id: status.id,
                        label: statusName
                    })
                }
            })
        }

        return (
            <div 
                ref={ref => this.innerRef = ref}
            >
                <PopMenu
                    isOpen={isOpen}
                    isStatuses={true}
                    options={options}
                    selectedOptionId={statusId}
                    selectCallback={this.setStatus}
                    closeMenu={closeMenu}
                    shouldGoUp={shouldGoUp}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        allStatuses: state.account.entities.statuses
    }
}

export default connect(mapStateToProps, {})(DashboardTasksStatus)


// WEBPACK FOOTER //
// ./src/sections/dashboard/dashboard-tasks-status.jsx